<script lang="ts">
    export default {
        inheritAttrs: false,
    }
</script>

<script lang="ts" setup>
    withDefaults(
        defineProps<{
            loading?: boolean
            rows?: number | string
            rowClasses?: string[]
        }>(),
        {
            loading: true,
            rows: 1,
            rowClasses: undefined,
        },
    )
</script>

<template>
    <Transition mode="out-in">
        <div v-if="loading" class="vv-skeleton">
            <slot name="skeleton">
                <div
                    v-for="i in typeof rows === 'string'
                        ? parseInt(rows)
                        : rows"
                    :key="i"
                    class="vv-skeleton__item"
                    :class="
                        rowClasses?.[i - 1] ? rowClasses[i - 1] : $attrs.class
                    "></div>
            </slot>
        </div>
        <slot v-else />
    </Transition>
</template>
